import React, { useEffect, useState, useRef } from 'react';
import { fetchAllPostPromisedData, fetchAllPromisedData } from '../../../../common/utils/methods/commonMethods/utilityMethod';
import { endpoint } from '../../../../common/constant';
import FeaturesList from './FeaturesList';
import TicketFormDialog from './TicketFormDialog';
import { failureToast, successToast } from '../../../../common/utils/methods/toasterFunctions/function';
import ActionButtonFooter from './ActionButtonFooter';
import ALoader from '../../../../common/a-loader';
import CopyFeaturesToBuDropdown from './CopyFeaturesBuDropdown';
import ViewHistory from './ViewHistory';
import styles from "./styles.module.scss";
import { Card, CardBody } from 'reactstrap';
import { getAuditDetails } from '../common';


const FeatureSetup = ({ buId, selectedTabValue, action }) => {

    const [featureSetupData, setFeatureSetupData] = useState({ fetching: false, data: [], currentPage: 0, totalRecords: 0 });

    const [reqObjForm, setReqObjForm] = useState(null);
    const viewOnly = action === 'view';

    const statusChangeHandler = (featureId, newStatus) => {

        if (viewOnly) return;

        setReqObjForm({ ...reqObjForm, featureId, ticketNo: '', isTicketFormOpen: true, status: newStatus })
    }

    const fetchFeatureSetupData = async (page = 0, setData = setFeatureSetupData, id = buId) => {
        try {
            setData(prev => ({ ...prev, fetching: true }))
            const resp = await fetchAllPromisedData(`${endpoint?.featureSetup?.getFeatureSetup}/${id}?offset=${page}`);
            const processedData = {
                fetching: false,
                data: resp?.businessAreaFeatureSetupList?.map((feature, index) => ({ ...feature, srNo: page * 10 + index + 1 })),
                currentPage: resp?.currentPage,
                totalRecords: resp?.totalRecords
            };
            setData(processedData);
        } catch (err) {
            console.error(err);
            setData(prev => ({ ...prev, fetching: false }))
        }
    }

    const resetForm = () => {
        setReqObjForm((prev)=>({...prev,isTicketFormOpen:false,ticketNo:""}));
    }

    const saveHandler = async (featureId) => {
        try {
            const { status, ticketNo } = reqObjForm;

            const reqObj = {
                state: status,
                ticketNumber: ticketNo?.trim()
            }
            if(!reqObj?.ticketNumber){
                failureToast('Status can not be same')
                return;
            }
           
            const resp = await fetchAllPostPromisedData(`${endpoint?.featureSetup?.updateFeatureState}/${reqObjForm?.featureId}`, reqObj);
            if (resp?.code === 200) {
                successToast("Request completed successfully!!")
                fetchFeatureSetupData();
                resetForm();
            }

        } catch (err) {
            console.log(err);
        }
    }

    const pageChangeHandler = (newPage) => {
        fetchFeatureSetupData(newPage);
    }

    const handleReqObjForm = (val, key) => setReqObjForm(prev => ({ ...prev, [key]: val }))

    useEffect(() => {
        buId && selectedTabValue?.key=='featureSetup' && fetchFeatureSetupData(0);
    }, [buId, selectedTabValue?.key])

    if (selectedTabValue.id !== 7) return null;

    return (
        <>
            {featureSetupData?.fetching && <ALoader position="fixed" />}
            <Card className='ml-0'>
                <CardBody>
                    <div className='d-flex justify-content-between'>
                        <div className='large-text color-grey-80'>Feature Setup</div>

                        <div className='d-flex justify-content-end' style={{ minWidth: '70%', columnGap: '10px' }}>

                            <ViewHistory
                                buId={buId}
                            />

                            {!viewOnly && <div style={{ minWidth: '50%' }}>
                                <CopyFeaturesToBuDropdown
                                    form={reqObjForm}
                                    setForm={setReqObjForm}
                                    buId={buId}
                                    fetchFeatureSetupData={fetchFeatureSetupData}
                                />
                            </div>
                            }

                        </div>
                    </div>
                    
                    <div className='mt-3' style={{border:'1px solid #E2E2E2'}}>

                    <FeaturesList
                        featuresData={featureSetupData?.data}
                        statusChangeHandler={statusChangeHandler}
                        form={reqObjForm}
                        setForm={setReqObjForm}
                        currentPage={featureSetupData?.currentPage}
                        totalRecords={featureSetupData?.totalRecords}
                        pageChangeHandler={pageChangeHandler}
                        saveHandler={saveHandler}
                        action={action}
                    />
                    </div>


                    <TicketFormDialog
                        form={reqObjForm}
                        handleForm={handleReqObjForm}
                        handleClose={resetForm}
                    />

                    {/* {
                    reqObjForm?.featureId &&
                        <ActionButtonFooter
                            discardHandler={resetForm}
                            saveHandler={saveHandler}
                        />
                    } */}
                    {featureSetupData?.data.length > 0 && getAuditDetails(featureSetupData?.data?.[0]?.updatedBy, featureSetupData?.data?.[0]?.updatedOn)}
                </CardBody>
            </Card>
        </>
    );
}

export default FeatureSetup;
